import React from "react";
import { Button, Checkbox, ConfigProvider, Divider, Input, Modal, Tooltip, Typography } from "antd";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import AddLinkIcon from "@mui/icons-material/AddLink";
import { InfoCircleOutlined, PauseOutlined, PlusOutlined } from '@ant-design/icons';
import tabby_logo from "../../../assets/images/tabby_logo.png";

const PayByLinkModal = ({ openLinkGen, handleCloseLinkGen, linkTitle, setLinkTitleHandler, linkDescription, setLinkDescriptionHandler, linkAmount, setLinkAmount, handle_tabby_enable_change, enable_tabby, pay_by_link_loading, handleLinkGen, linkVATPercent, setLinkVATPercent, disablePercentEdit, linkFeePercent, setLinkFeePercent, theLink, copyToClipboardModern, load_send_link_to_wati, handleSendWatiLink }) => {



    return (
        <>
            <Modal
                title={`Generate a Mamopay Pay-by-Link (${openLinkGen?.data?.query_id || "Unknown Query ID"})`
                }
                open={openLinkGen?.open}
                onCancel={handleCloseLinkGen}
                centered
                width={550}
                maskClosable={false}
                footer={< div className="flex justify-end" >
                    <div>
                        <ConfigProvider
                            theme={{
                                components: {
                                    Button: {
                                        defaultHoverColor: "#ffffff",
                                        defaultColor: "#ffffff",
                                        defaultHoverBg: "#3be368",
                                        defaultBg: "#31bd56",
                                    },
                                },
                            }}
                        >
                            <Button
                                loading={pay_by_link_loading}
                                endIcon={<AddLinkIcon />}
                                variant="contained"
                                onClick={handleLinkGen}
                            >
                                Request Link
                            </Button>
                        </ConfigProvider>
                    </div>
                </div >}>
                <div className="gap-2 grid border rounded drop-shadow p-2" style={{ backgroundColor: "#f7f7f7" }}>
                    <div className="border rounded p-2 gap-2 grid" style={{ backgroundColor: "#fbfbfb" }}>
                        <div className="flex gap-1">
                            <div className="flex justify-between" style={{ width: "120px" }}><span>Title</span><span>:</span></div>
                            <div className="flex gap-1" style={{ width: "75%" }}>
                                <Input
                                    maxLength={50}
                                    placeholder="Title"
                                    allowClear
                                    required
                                    value={linkTitle}
                                    onChange={(e) => {
                                        setLinkTitleHandler(e.target.value);
                                    }}
                                />
                                <Tooltip title="Title must be less than 50 characters">
                                    <InfoCircleOutlined />
                                </Tooltip>
                            </div>
                        </div>
                        <div className="flex gap-1 justify-between">
                            <div className="flex justify-between" style={{ width: "120px" }}><span>Description</span><span>:</span></div>
                            <div className="flex gap-1" style={{ width: "75%" }}>
                                <Input
                                    placeholder="Description"
                                    allowClear
                                    required
                                    value={linkDescription}
                                    onChange={(e) => {
                                        setLinkDescriptionHandler(e.target.value);
                                    }}
                                />
                                <Tooltip title="Description must be less than 70 characters">
                                    <InfoCircleOutlined />
                                </Tooltip>
                            </div>
                        </div>
                        <div className="flex gap-1 justify-between">
                            <div className="flex justify-between" style={{ width: "120px" }}><span>Amount</span><span>:</span></div>
                            <div className="flex gap-1" style={{ width: "75%" }}>
                                <Input
                                    placeholder="Amount"
                                    allowClear
                                    required
                                    value={linkAmount}
                                    onChange={(e) => {
                                        if (/^\d*\.?\d*$/.test(e.target.value)) {
                                            setLinkAmount(e.target.value);
                                        }
                                    }}
                                />
                                <span className="flex">
                                    <span className="flex items-center">
                                        <Divider type="vertical" />
                                    </span>
                                    <span className="flex items-center">
                                        <Tooltip title="Enable tabby while checkout">
                                            <Checkbox
                                                className="flex items-center"
                                                onChange={(e) => handle_tabby_enable_change(e)}
                                                value={enable_tabby}>
                                                <img src={tabby_logo} className="flex items-center" style={{ width: "70px" }} />
                                            </Checkbox>
                                        </Tooltip>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div className="flex gap-1 justify-between">
                            <div className="flex justify-between" style={{ width: "120px" }}><span>VAT %</span><span>:</span></div>
                            <div className="flex gap-1" style={{ width: "75%" }}>
                                <Input
                                    placeholder="Processing Fee %"
                                    allowClear
                                    required
                                    value={linkVATPercent}
                                    onChange={(e) => {
                                        if (/^\d*\.?\d*$/.test(e.target.value)) {
                                            setLinkVATPercent(e.target.value)
                                        }
                                    }}
                                    addonAfter={"%"}
                                />
                                <Tooltip title="Usually it is 5%">
                                    <InfoCircleOutlined />
                                </Tooltip>
                            </div>
                        </div>
                        <div className="flex gap-1 justify-between">
                            <div className="flex justify-between" style={{ width: "120px" }}><span>Processing Fee %</span><span>:</span></div>
                            <div className="flex gap-1" style={{ width: "75%" }}>
                                <Input
                                    placeholder="Processing Fee %"
                                    allowClear
                                    max={5}
                                    disabled={disablePercentEdit}
                                    required
                                    value={linkFeePercent}
                                    onChange={(e) => {
                                        if (/^\d*\.?\d*$/.test(e.target.value)) {
                                            setLinkFeePercent(e.target.value)
                                        }
                                    }}
                                    addonAfter={"%"}
                                />
                                <Tooltip title="Processing fee must be less than 5%">
                                    <InfoCircleOutlined />
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-1 justify-center border rounded" style={{ backgroundColor: "#fbfbfb", width: "100%" }}>
                        <div className="flex justify-between p-2 pt-3">

                            <div className="border rounded pl-0.5 pr-0.5 drop-shadow ml-1" style={{ marginBottom: "8px", marginTop: "8px" }}>

                                <div style={{ fontSize: "8px", transform: "translateY(-10px)", marginBottom: "-11px", background: "white", display: "table", borderRadius: "10px", fontWeight: "600" }}>&nbsp;Price&nbsp;</div>
                                <div style={{ fontWeight: "600", fontSize: "16px" }}>
                                    {linkAmount}
                                </div>

                            </div>

                            <div className="flex items-center pl-2 pr-2"><PlusOutlined /></div>

                            <div className="border rounded pl-0.5 pr-0.5 drop-shadow ml-1" style={{ marginBottom: "8px", marginTop: "8px" }}>

                                <div style={{ fontSize: "8px", transform: "translateY(-10px)", marginBottom: "-11px", background: "white", display: "table", borderRadius: "10px", fontWeight: "600" }}>&nbsp;VAT&nbsp;</div>
                                <div style={{ fontWeight: "600", fontSize: "16px" }}>
                                    {(linkAmount * (linkVATPercent / 100)).toFixed(2) || 0}
                                </div>

                            </div>

                            <div className="flex items-center pl-2 pr-2"><PlusOutlined /></div>

                            <div className="border rounded pl-0.5 pr-0.5 drop-shadow ml-1" style={{ marginBottom: "8px", marginTop: "8px" }}>

                                <div style={{ fontSize: "8px", transform: "translateY(-10px)", marginBottom: "-11px", background: "white", display: "table", borderRadius: "10px", fontWeight: "600" }}>&nbsp;Processing Fee&nbsp;</div>
                                <div style={{ fontWeight: "600", fontSize: "16px" }}>
                                    {((parseFloat((linkAmount * (1 + linkVATPercent / 100)).toFixed(2) || 0)) * (linkFeePercent / 100)).toFixed(2) || 0}
                                </div>


                            </div>

                            <div className="flex items-center pl-2 pr-2 rotate-90"><PauseOutlined /></div>

                            <div className="border rounded pl-0.5 pr-0.5 drop-shadow ml-1 pt-1" style={{ fontSize: "22px", fontWeight: "700" }}>
                                <span style={{ fontSize: "18px", color: "gray" }}>AED</span>{(parseFloat(linkAmount) + parseFloat(((linkAmount * (linkVATPercent / 100)) || 0)) + ((parseFloat((linkAmount * (1 + linkVATPercent / 100)) || 0)) * (linkFeePercent / 100)) || 0).toFixed(2)}
                            </div>
                        </div>
                    </div>

                    <div className="border rounded p-2 gap-2 grid" style={{ backgroundColor: "#fbfbfb" }}>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <Typography>Generated Link</Typography>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <Typography>{theLink ? (<Tooltip title="Click on the link to copy it to the clipboard."><div className="cursor-pointer" onClick={() => copyToClipboardModern(theLink, "Payment Link")}>{theLink}</div></Tooltip>) : (<i style={{ color: "gray" }}>Generate Link First</i>)}</Typography>
                        </div>
                        <div style={{ height: "7px" }}></div>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Button: {
                                            defaultHoverColor: "#ffffff",
                                            defaultColor: "#ffffff",
                                            defaultHoverBg: "#3be368",
                                            defaultBg: "#31bd56",
                                        },
                                    },
                                }}
                            >
                                <Button
                                    id="link_gen_send_wati"
                                    endIcon={<SendOutlinedIcon />}
                                    variant="contained"
                                    loading={load_send_link_to_wati}
                                    onClick={handleSendWatiLink}
                                    style={{ display: "none" }}
                                >
                                    SEND TO CUSTOMER ON WATI
                                </Button>
                            </ConfigProvider>
                        </div>
                    </div>
                </div>
            </Modal >

        </>

    );
}

export default PayByLinkModal;